import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  background-image: url("img/assessments-decoration.svg");
  background-repeat: no-repeat;
  background-size: 80px;
  padding: 2em;
  margin-top: 3em;
`;

export const Photo = styled.img`
  min-width: 105px;
  max-width: 208px;
  width: 100%;
  margin: 0 2em 0 4em;
`;

export const Content = styled.div`
  flex: 1;
`;

export const Title = styled.h2`
  font-size: 36px;
  font-weight: normal;
  margin: 0.5em 0 0;

  span {
    font-size: 48px;
    display: block;
  }
`;

export const Description = styled.p`
  color: #888888;
  line-height: 200%;
  font-size: 14px;
  margin: 2em 0;
`;
